import React from 'react';

import { useTranslation } from '@crehana/i18n';
import { LazyImage } from '@crehana/ui';

interface EmptyResultsProps {
  notFoundDescription: string;
  cleanFiltersMsg: string;
  onClearFilters: () => void;
}

const EmptyResults: React.FC<EmptyResultsProps> = ({
  notFoundDescription,
  cleanFiltersMsg,
  onClearFilters,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row items-center rounded-5 bg-gray-lighter py-24 px-72 mb-24">
      <LazyImage
        src="https://crehana-public-catalog.imgix.net/images/app/gallery/2021/09/24/ddd39098/da61dd02.png"
        alt="banner empty results"
        className="h-160 w-160 mb-24 sm:mb-0"
        isTransparent
        imgxParams={{
          w: 160,
          h: 160,
          dpr: 2,
        }}
      />

      <div className="sm:ml-64 flex flex-col justify-center text-center sm:text-left">
        <h2 className="font-subtitle3 tw-font-semibold mb-16 sm:mb-8">
          {t('CATALOG_NOT_RESULTS_FOR', {
            interpolation: { name: notFoundDescription },
          })}
        </h2>
        <p className="font-body4 mb-16">{t('RESULTS_EMPTY_SUBTITLE')}</p>

        <div className="block sm:hidden">
          <button
            type="button"
            className="font-subtitle3 text-secondary-main"
            onClick={onClearFilters}
          >
            {cleanFiltersMsg}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmptyResults;
